import { render, staticRenderFns } from "./PendenciasDistrito.vue?vue&type=template&id=2f4a99e2"
import script from "./PendenciasDistrito.vue?vue&type=script&lang=ts"
export * from "./PendenciasDistrito.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports